import React from 'react';
import { PlusSmall, MinusSmall } from '@blueprint/icons';
import { Container, Button } from './ZoomControl.styles';

type Props = {
    isZoomInEnabled: boolean;
    isZoomOutEnabled: boolean;
    onZoomIn?: () => void;
    onZoomOut?: () => void;
};
const ZoomControl = ({
    isZoomInEnabled = true,
    isZoomOutEnabled = true,
    onZoomIn = () => null,
    onZoomOut = () => null
}: Props) => {
    return (
        <Container>
            <Button
                aria-label="Zoom in"
                onClick={(event: React.SyntheticEvent) => {
                    event.stopPropagation();
                    onZoomIn();
                }}
                disabled={!isZoomInEnabled}
                data-testid="zoom-control-in"
            >
                <PlusSmall />
            </Button>
            <Button
                aria-label="Zoom out"
                onClick={(event: React.SyntheticEvent) => {
                    event.stopPropagation();
                    onZoomOut();
                }}
                disabled={!isZoomOutEnabled}
                data-testid="zoom-control-out"
            >
                <MinusSmall />
            </Button>
        </Container>
    );
};

export default ZoomControl;
